import { getFileExtension, processFiles } from '../../../../utils/photoUpload';

interface ImageBlob extends Blob {
  lastModifiedDate?: Date;
  lastModified?: number;
  name?: string;
}

export const cropImage = (url: string): Promise<string> => {
  return new Promise(resolve => {
    const inputImage = new Image();

    inputImage.onload = () => {
      const aspectRatio = 3 / 4;
      const inputWidth = inputImage.naturalWidth;
      const inputHeight = inputImage.naturalHeight;
      const inputImageAspectRatio = inputWidth / inputHeight;

      let outputWidth = inputWidth;
      let outputHeight = inputHeight;

      if (inputImageAspectRatio > aspectRatio) {
        outputWidth = inputHeight * aspectRatio;
      } else if (inputImageAspectRatio < aspectRatio) {
        outputHeight = inputWidth / aspectRatio;
      }

      const outputX = (outputWidth - inputWidth) * 0.5;
      const outputY = (outputHeight - inputHeight) * 0.5;

      const outputImage = document.createElement('canvas');

      outputImage.width = outputWidth;
      outputImage.height = outputHeight;

      const ctx = outputImage.getContext('2d');

      if (ctx) {
        ctx.drawImage(inputImage, outputX, outputY);
        resolve(outputImage.toDataURL());
      } else {
        console.log('ctx is null');
      }
    };

    inputImage.src = url;
  });
};

export function b64toBlob(dataURI: string): Blob {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: 'image/jpeg' });
}

export function generateImageBlob(imageFile: string, filename?: string, cb?: () => void): Blob {
  const blobImage: ImageBlob = b64toBlob(imageFile);

  blobImage.lastModifiedDate = new Date();
  blobImage.lastModified = +blobImage.lastModifiedDate;
  blobImage.name = filename || 'img.jpg';
  if (blobImage.size <= 0) {
    if (cb) {
      cb();
    }

    throw Error('GENERATE_BLOB_ERROR');
  }
  return blobImage;
}

//update photo worker logic
export const preparePhotoMediaList = async (validFiles: File[]) => {
  let errorMessage = '';

  try {
    const processedResults = await processFiles(Array.from(validFiles));

    const results = processedResults
      .filter(result => result.data !== null)
      .map((result, index) => ({
        index,
        edited: result.data,
        raw: result.data,
        id: result.id,
        private: false,
        primary: false,
        fileExtension: getFileExtension(result.id),
      }));

    const failedFiles = processedResults.filter(result => result.data === null).map(result => result.id);

    if (failedFiles.length > 0) {
      const formattedFailedFiles = failedFiles.join(', ');

      errorMessage = `${"The following images couldn't be processed: "}${formattedFailedFiles}`;
    }

    return { results, errorMessage };
  } catch (error) {
    console.warn('error', error);
    errorMessage = 'An error occurred while processing the images. Please try again.';
    return { results: [], errorMessage };
  }
};
